export function inputFileStyle() {
  const fileInputsContainer = document.querySelectorAll('.js-form-file');
  if(fileInputsContainer.length) {
    fileInputsContainer.forEach(function(el) {
      const input = el.querySelector('input[type=file]')
      const hidden = el.querySelector('input[type=hidden]')
      const label = el.querySelector('.js-input-file-label');
      const textEmpty = label.getAttribute('data-label-empty');
      function change() {
        const file = input.files[0];
        if (label) {
          if(input.files[0]) {
            label.textContent = file.name;
          } else {
            label.textContent = textEmpty;
          }
        }
      }
      input.addEventListener('change', change);
      change();
      if(hidden && hidden.value !== '') {
        label.textContent = hidden.value;
      }
    });
  }
}